document.addEventListener('wpcf7mailsent', function (event) {
  const form = event.target;
  if (!form) return;

  const formSlugInput = form.querySelector('input[name="form_slug"]');
  const formSlug = formSlugInput ? formSlugInput.value : '';

  // No redirect for specific forms
  if (formSlug === 'waiting-list-investment-form') return;

  // Save city to sessionStorage before redirect so it survives the page change
  let city = '';
  (window.dataLayer || []).forEach(entry => {
    if (!city && entry.page_location_city) city = entry.page_location_city;
  });
  if (!city && event.detail?.inputs) {
    event.detail.inputs.forEach(input => {
      if (input.name === 'miasto') city = input.value;
    });
  }
  if (city) sessionStorage.setItem('najm_form_city', city);

  const currentUrl = new URL(window.location.href);
  currentUrl.searchParams.set('submission', 'sent');

  const formId = form.id;
  if (formId) {
    currentUrl.searchParams.set('form', formId);
  }

  setTimeout(() => {
    window.location.href = currentUrl.toString();
  }, 500);
}, false);

document.addEventListener('DOMContentLoaded', () => {
  const urlParams = new URLSearchParams(document.location.search);

  // Push form_submission event on thank-you page
  if (urlParams.get('submission') === 'sent') {
    const city = sessionStorage.getItem('najm_form_city');
    if (city) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'form_submission', apartment_location: city });
      sessionStorage.removeItem('najm_form_city');
    }
  }

  // Scroll to form after redirect
  const formParam = urlParams.get('form');
  if (formParam) {
    const target = document.querySelector(`#${formParam}-wrapper`);
    if (target) {
      setTimeout(() => {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 400);
    }
  }
});
